import produce from 'immer';
import { Reducer } from 'redux';

import {
  IModalState,
  IModalActionsType,
  IModalTypes,
  StatusOption,
} from './types';

const INITIAL_STATE: IModalState = {
  loadingSubmit: false,

  submitStatus: StatusOption.REQUEST,
};

const modal: Reducer<IModalState, IModalActionsType> = (
  state = INITIAL_STATE,
  action: IModalActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IModalTypes.SUBMIT_MODAL_REQUEST: {
        draft.loadingSubmit = true;
        draft.submitStatus = StatusOption.REQUEST;
        break;
      }
      case IModalTypes.SUBMIT_MODAL_SUCCESS: {
        draft.loadingSubmit = false;
        draft.submitStatus = StatusOption.SUCCESS;
        break;
      }
      case IModalTypes.SUBMIT_MODAL_FAILURE: {
        draft.loadingSubmit = false;
        draft.submitStatus = StatusOption.FAILURE;
        break;
      }
      case IModalTypes.SUBMIT_MODAL_RESET: {
        draft.loadingSubmit = false;
        draft.submitStatus = StatusOption.REQUEST;
        break;
      }

      default:
    }
  });
};
export default modal;
